import { checkTheme, Themes } from 'carrier-fe';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

function SupportLayout() {
	const navigate = useNavigate();

	useEffect(() => {
		if (!checkTheme(Themes.Viessmann) && !checkTheme(Themes.Toshiba)) {
			navigate('/dashboard');
		}
	}, []);

	return <Outlet />;
}

export default SupportLayout;
